<main class="flex flex-col justify-center content-center h-full w-full">
  <article
    class="mx-4 md:mx-0 flex flex-col justify-between self-center border rounded-md w-[150em] p-12">
    <h1 class="text-base text-center">
      @if (!errorReason) {
        No configuration found for the determined club.
      } @else if (errorReason === 'invalid-group-link') {
        Invalid Group Link: The group link '{{ groupLink }}' is inactive or does
        not exist. Please contact support.
      } @else if (errorReason === 'network-error') {
        Network Error: Unable to validate group link. Please check your
        connection and try again.
      } @else {
        An unexpected error occurred. Please contact support.
      }
    </h1>
    @if (errorCode) {
      <p class="text-sm text-center text-gray-500 mt-2">
        Error Code: {{ errorCode }}
      </p>
    }
  </article>
</main>
